import {JsFormResponseHandlerObject} from '../jsFormTypes';
import {JRpcResponse, JsonRpcResponseFactory} from '../jsonRpc/jsonRpcResponseFactory';
import {JRpcErrResponse} from '../jsonRpc/jRpcErrResponse';
import {JRpcSuccResponse} from '../jsonRpc/jRpcSuccResponse';
import {Localization} from '../../../localization/localization';
import {ErrorToolTip, TooltipDirection} from '../../newErrorToolTip';
import {isValidEmail} from '../validators';
import { disableJsFormHandler } from '../jsForm';
import {GtmSender} from '../../../marketing/GtmSender';
import {SystemEvents} from '../../../constants/gameEvents';
import {StretchPopup} from '../../../popups/stretchPopup';
import { configureHttpAuth } from '../../../startup/configureHttpAuth';
import { AuthStepConversionSend } from '../../../marketing/auth-step-conversion-send';
import { Url } from '../url';

// TODO wtf is getMain? (rename)
function getMain(caller: HTMLElement|JQuery<HTMLElement>) {
    const result = $(caller).closest('.js-main');
    const id = $(result).attr('id');
    return $(`#${id}`);
}

let errorToolTip: ErrorToolTip;

$(() => {
    errorToolTip = ErrorToolTip.getTooltipElement();

    $('.js-close-button-reg').on('click', function handleV3CloseButtonClick() {
        const main = getMain(this);
        main.removeClass('step1 step2 step3');
        main.addClass('step1');
        StretchPopup.stretch();
    });

    $('.js-form .button-back').on('click', function handleV3BackButtonClick() {
        const main = getMain(this);
        main.removeClass('step1 step2 step3');
        main.addClass('step1');
        StretchPopup.stretch();
    });
});


// REGISTRATION V3
window.app.registrationPollStep1 = step1;
window.app.registrationPollStep2 = step2;
window.app.registrationPollStep3 = step3;

function step1(data: JsFormResponseHandlerObject<JRpcResponse<{}>>) {
    const $form = data.form;
    const $termsCheckbox = $('.js-terms_agree', $form);
    const email = $('input[name=email]', $form).val() as string;
    const toolTipDirection: keyof typeof TooltipDirection = data.caller.data('tooltipdirection');
    const toolTipDirectionSide: TooltipDirection = TooltipDirection[toolTipDirection];
    const emailInput = $('input[name=email]', data.form);
    const emailInputContainer = emailInput.parents('.white_input');

    $('.error', data.form).removeClass('error');

    if ($termsCheckbox.length && !$termsCheckbox.hasClass('checked')) {
        errorToolTip.showTooltipElement(
            $termsCheckbox,
            toolTipDirectionSide as TooltipDirection,
            Localization._n('agree_error'),
            true
        );

        return false;
    }

    if (!isValidEmail(email)) {
        emailInputContainer.addClass('error');
        errorToolTip.showTooltipElement(
            emailInput,
            toolTipDirectionSide as TooltipDirection,
            Localization._n('wrong_data')
        );
        return false;
    }

    const main = getMain(data.caller);
    main.removeClass('step1 step2');
    main.addClass('step2');
    data.caller.removeAttr('disabled');
    StretchPopup.stretch();

    const authStepConversionSender = new AuthStepConversionSend(window.location);
    authStepConversionSender.send('2');

    return true;
}


async function step2(data: JsFormResponseHandlerObject<JRpcResponse<{}>>) {
    const $form = data.form;
    const passwordInput = $('input[name=password]', $form);
    const toolTipDirection: keyof typeof TooltipDirection = data.caller.data('tooltipdirection');
    const toolTipDirectionSide: TooltipDirection = TooltipDirection[toolTipDirection];
    const passwordInputContainer = passwordInput.parents('.white_input');

    $('.error', data.form).removeClass('error');

    const passwordValue = passwordInput.val().toString()
        .trim();
    if (passwordValue.length) {
        const main = getMain(data.caller);
        main.removeClass('step2 step3');
        main.addClass('step3');
        data.caller.removeAttr('disabled');
        StretchPopup.stretch();

        const authStepConversionSender = new AuthStepConversionSend(window.location);
        authStepConversionSender.send('3');

        return true;
    }

    data.caller.removeAttr('disabled');
    passwordInputContainer.addClass('error');
    errorToolTip.showTooltipElement(
        passwordInput,
        toolTipDirectionSide as TooltipDirection,
        Localization._n('errors.pass_empty')
    );

    return false;
}


function step3(data: JsFormResponseHandlerObject<JRpcResponse<{}>>) {
    const response = (new JsonRpcResponseFactory<{
        huid: number
    }>()).getJsonRpcResponseFromObject(data.response);
    const toolTipDirection: keyof typeof TooltipDirection = data.caller.data('tooltipdirection');
    const toolTipDirectionSide: TooltipDirection = TooltipDirection[toolTipDirection];

    $('.error', data.form).removeClass('error');

    if (response instanceof JRpcErrResponse) {
        errorToolTip.showTooltipElement(
            data.caller,
            toolTipDirectionSide as TooltipDirection,
            response.error.message
        );
        return;
    }

    if (response instanceof JRpcSuccResponse) {
        const userSourceAd = $('.step3 .js-subscription_agree.checked').attr('id');
        const userSourceAdValue = userSourceAd ? userSourceAd : 'NULL';
        const url = Url.current();
        url.addQueryParam('poll', userSourceAdValue);

        window.app.user_huid = response.result.huid;
        configureHttpAuth();
        GtmSender.fireMarketing(SystemEvents.EMAIL_REG_SUCCESS);
        disableJsFormHandler(data.form);

        url.setHref();
        return;
    }

    errorToolTip.showTooltipElement(
        data.caller,
        toolTipDirectionSide as TooltipDirection,
        Localization._n('common_error')
    );
}
